/* ═══════════════════════════════════════════════════════════
   EI-ARTICLE-BLOG.JS — L'Entrepôt Italien
   VERSION : v5.1 — Total prix + ajout séquentiel
   Fichier : assets/ei-article-blog.js
   ═══════════════════════════════════════════════════════════ */

(function($) {
  'use strict';

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function() { window.dataLayer.push(arguments); };
  }

  function eiTrack(event, params) {
    params = params || {};
    params.ei_source  = params.ei_source  || eiGetArticleSource();
    params.ei_version = params.ei_version || 'v5_1';
    if (typeof window.gtag === 'function') window.gtag('event', event, params);
    if (window.location.search.indexOf('ei_debug=1') > -1) console.log('[EI Track]', event, params);
  }

  function eiGetArticleSource() {
    var path = window.location.pathname;
    var match = path.match(/\/blogs\/[^\/]+\/([^\/\?]+)/);
    return match ? 'article_' + match[1].replace(/-/g, '_').substring(0, 40) : 'article_unknown';
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' \u20ac';
  }

  /* ═══ AJAX ADD TO CART ═══ */

  function ajaxAddToCart(variantId, qty, successCb, errorCb) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { id: variantId, quantity: qty || 1 },
      dataType: 'json',
      success: function(item) {
        eiTrack('ei_add_to_cart_success', {
          ei_action: 'add_to_cart_success',
          ei_product: item.handle || item.title,
          ei_variant_id: String(variantId),
          ei_quantity: String(qty || 1),
          ei_price: String(item.price)
        });
        if (typeof ajaxCart !== 'undefined' && typeof ajaxCart.load === 'function') ajaxCart.load();
        $.getJSON('/cart.js', function(cart) {
          $('.enj-cartcount').text(cart.item_count);
          $('.enj-cartcost').text(formatMoney(cart.total_price));
        });
        if (typeof successCb === 'function') successCb(item);
      },
      error: function(xhr) {
        var msg = 'Erreur lors de l\'ajout au panier';
        try { var resp = JSON.parse(xhr.responseText); if (resp.description) msg = resp.description; } catch(e) {}
        if (typeof errorCb === 'function') { errorCb(msg); } else { alert(msg); }
      }
    });
  }

  /* ═══ RENDU FICHES PRODUIT SHOPPABLE + TOTAL ═══ */

  function renderShoppableBlocks() {
    $('.ei-shoppable-ingredients').each(function() {
      var $block = $(this);
      var handlesStr = $block.attr('data-handles');
      if (!handlesStr) return;

      var handles = handlesStr.split(',').map(function(h) { return h.trim(); }).filter(Boolean);
      var $container = $block.find('.ei-shoppable-items');
      $container.empty();

      var totalCents = 0;
      var loaded = 0;
      var expected = handles.length;

      handles.forEach(function(handle) {
        $.getJSON('/products/' + handle + '.js')
          .done(function(product) {
            var variant = product.variants[0];
            if (!variant) return;
            totalCents += variant.price;

            var imgSrc = product.featured_image
              ? product.featured_image.replace(/(\.[^\.]+)$/, '_180x180$1')
              : '';

            var card = '<div class="ei-product-card">' +
              (imgSrc ? '<a href="/products/' + handle + '" class="ei-product-card__img-link"><img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="ei-product-card__img" loading="lazy"></a>' : '') +
              '<div class="ei-product-card__info">' +
                '<a href="/products/' + handle + '" class="ei-product-card__name">' + product.title + '</a>' +
                '<span class="ei-product-card__price">' + formatMoney(variant.price) + '</span>' +
              '</div>' +
              '<button class="ei-add-to-cart" data-variant-id="' + variant.id + '" aria-label="Ajouter ' + product.title.replace(/"/g, '&quot;') + '">+</button>' +
            '</div>';
            $container.append(card);
          })
          .fail(function() { console.warn('[EI] Produit introuvable :', handle); })
          .always(function() {
            loaded++;
            if (loaded === expected) renderTotal($block, totalCents, loaded);
          });
      });
    });
  }

  function renderTotal($block, totalCents, count) {
    $block.find('.ei-shoppable-total').remove();
    if (totalCents <= 0 || count === 0) return;
    var html =
      '<div class="ei-shoppable-total">' +
        '<span class="ei-shoppable-total__count">' + count + ' produit' + (count > 1 ? 's' : '') + '</span>' +
        '<span class="ei-shoppable-total__price">Total : ' + formatMoney(totalCents) + '</span>' +
      '</div>';
    var $ctaBtn = $block.find('.ei-shoppable-cta-all');
    if ($ctaBtn.length) { $ctaBtn.before(html); } else { $block.find('.ei-shoppable-items').after(html); }
  }

  /* ═══ RENDU BLOC COFFRET ═══ */

  function renderCoffretBlock() {
    var $coffret = $('#ei-coffret-block');
    if (!$coffret.length) return;
    var handle = window.EI_COFFRET_HANDLE;
    if (!handle) return;

    $.getJSON('/products/' + handle + '.js')
      .done(function(product) {
        var variant = product.variants[0];
        if (!variant) return;
        var imgSrc = product.featured_image ? product.featured_image.replace(/(\.[^\.]+)$/, '_400x400$1') : '';
        var priceHTML = '<span class="ei-coffret-price">' + formatMoney(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceHTML = '<span class="ei-coffret-compare">' + formatMoney(variant.compare_at_price) + '</span> ' + priceHTML;
        }
        var html = '<div class="ei-coffret-section" data-coffret-handle="' + handle + '">' +
          '<div class="ei-coffret-inner">' +
            (imgSrc ? '<a href="/products/' + handle + '" class="ei-coffret-img-link"><img src="' + imgSrc + '" alt="' + product.title.replace(/"/g, '&quot;') + '" class="ei-coffret-img" loading="lazy"></a>' : '') +
            '<div class="ei-coffret-info">' +
              '<span class="ei-coffret-badge">Coffret recette</span>' +
              '<h3 class="ei-coffret-title">' + product.title + '</h3>' +
              '<p class="ei-coffret-desc">' + (product.description ? product.description.replace(/<[^>]+>/g, '').substring(0, 160) + '...' : '') + '</p>' +
              '<div class="ei-coffret-pricing">' + priceHTML + '</div>' +
              '<button class="ei-coffret-add ei-add-to-cart" data-variant-id="' + variant.id + '">Ajouter au panier \u2192</button>' +
              '<a href="/products/' + handle + '" class="ei-coffret-link">Voir le coffret \u2192</a>' +
            '</div>' +
          '</div>' +
        '</div>';
        $coffret.html(html);
      })
      .fail(function() { console.warn('[EI] Coffret introuvable :', handle); });
  }

  /* ═══ BADGE DATE ═══ */

  function setDateBadge() {
    var $badge = $('#ei-date-badge');
    if (!$badge.length) return;
    var dateStr = null;
    $('script[type="application/ld+json"]').each(function() {
      try { var json = JSON.parse($(this).text()); if (json.dateModified) { dateStr = json.dateModified; return false; } } catch(e) {}
    });
    if (dateStr) {
      var d = new Date(dateStr);
      if (!isNaN(d.getTime())) {
        var months = ['janvier','f\u00e9vrier','mars','avril','mai','juin','juillet','ao\u00fbt','septembre','octobre','novembre','d\u00e9cembre'];
        $badge.text('Mis \u00e0 jour le ' + d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear());
      }
    }
  }

  /* ═══ STICKY BAR MOBILE ═══ */

  function initStickyBar() {
    var $sticky = $('#ei-sticky-bar');
    if (!$sticky.length) return;
    $sticky.css({ transform: 'translateY(100%)', transition: 'transform .3s ease' });
    var stickyVisible = false, stickyTracked = false;
    $(window).on('scroll.eiSticky', function() {
      var st = $(window).scrollTop();
      if (st > 600 && !stickyVisible) {
        stickyVisible = true;
        $sticky.css('transform', 'translateY(0)');
        if (!stickyTracked) { stickyTracked = true; eiTrack('ei_sticky_bar_view', { ei_action: 'sticky_bar_view' }); }
      } else if (st <= 600 && stickyVisible) {
        stickyVisible = false;
        $sticky.css('transform', 'translateY(100%)');
      }
    });
  }

  /* ═══ MODE CUISINE ═══ */

  function initCookMode() {
    $(document).on('click', '.ei-rc__cook-mode', function(e) {
      e.preventDefault();
      var $card = $(this).closest('.ei-rc');
      var idx = $('.ei-rc').index($card);
      eiOpenCookMode('r' + (idx + 1));
    });
    $(document).on('click', '.ei-cook__close', function(e) {
      e.preventDefault();
      var id = $(this).closest('.ei-cook-overlay').attr('id').replace('ei-cook-', '');
      eiCloseCookMode(id);
    });
    $(document).on('click', '.ei-cook__nav-next', function(e) {
      e.preventDefault();
      var $ov = $(this).closest('.ei-cook-overlay');
      var $a = $ov.find('.ei-cook__step.active');
      var $n = $a.next('.ei-cook__step');
      if ($n.length) { $a.removeClass('active'); $n.addClass('active'); updateProgress($ov); }
    });
    $(document).on('click', '.ei-cook__nav-prev', function(e) {
      e.preventDefault();
      var $ov = $(this).closest('.ei-cook-overlay');
      var $a = $ov.find('.ei-cook__step.active');
      var $p = $a.prev('.ei-cook__step');
      if ($p.length) { $a.removeClass('active'); $p.addClass('active'); updateProgress($ov); }
    });
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        $('.ei-cook-overlay.active').each(function() { eiCloseCookMode($(this).attr('id').replace('ei-cook-', '')); });
      }
    });
  }

  function updateProgress($ov) {
    var $steps = $ov.find('.ei-cook__step');
    var cur = $steps.index($ov.find('.ei-cook__step.active')) + 1;
    $ov.find('[id^="ei-cook-progress-"]').css('width', Math.round((cur / $steps.length) * 100) + '%');
  }

  window.eiOpenCookMode = function(id) {
    var ov = document.getElementById('ei-cook-' + id);
    if (!ov) return;
    ov.classList.add('active');
    document.body.style.overflow = 'hidden';
    eiTrack('ei_cook_mode_open', { ei_action: 'mode_cuisine', ei_product: id });
    var $ov = $(ov);
    $ov.find('.ei-cook__step').removeClass('active');
    $ov.find('.ei-cook__step').first().addClass('active');
    updateProgress($ov);
  };

  window.eiCloseCookMode = function(id) {
    var ov = document.getElementById('ei-cook-' + id);
    if (!ov) return;
    ov.classList.remove('active');
    document.body.style.overflow = '';
    $(ov).find('[id^="timer-"]').each(function() { eiStopTimer($(this).attr('id').replace('timer-', '')); });
  };

  /* ═══ TIMERS ═══ */

  var eiTimers = {};

  function initTimers() {
    $(document).on('click', '.ei-cook__timer-start', function(e) {
      e.preventDefault();
      var $d = $(this).closest('.ei-cook__step').find('[id^="timer-"]');
      if (!$d.length) return;
      var tid = $d.attr('id').replace('timer-', '');
      var parts = $d.text().trim().split(':');
      var sec = (parseInt(parts[0], 10) || 0) * 60 + (parseInt(parts[1], 10) || 0);
      if (sec <= 0) return;
      eiStartTimer(tid, sec);
      $(this).text('Pause').removeClass('ei-cook__timer-start').addClass('ei-cook__timer-pause');
    });
    $(document).on('click', '.ei-cook__timer-pause', function(e) {
      e.preventDefault();
      var $d = $(this).closest('.ei-cook__step').find('[id^="timer-"]');
      if (!$d.length) return;
      eiStopTimer($d.attr('id').replace('timer-', ''));
      $(this).text('Reprendre').removeClass('ei-cook__timer-pause').addClass('ei-cook__timer-start');
    });
    $(document).on('click', '.ei-cook__timer-reset', function(e) {
      e.preventDefault();
      var $step = $(this).closest('.ei-cook__step');
      var $d = $step.find('[id^="timer-"]');
      if (!$d.length) return;
      eiStopTimer($d.attr('id').replace('timer-', ''));
      var init = $d.data('initial');
      if (init) $d.text(init);
      $d.css('color', '');
      $step.find('.ei-cook__timer-pause').text('D\u00e9marrer').removeClass('ei-cook__timer-pause').addClass('ei-cook__timer-start');
    });
  }

  window.eiStartTimer = function(id, totalSec) {
    if (eiTimers[id]) return;
    eiTrack('ei_timer_start', { ei_action: 'timer_start', ei_product: id });
    var display = document.getElementById('timer-' + id);
    if (!display) return;
    var $d = $(display);
    if (!$d.data('initial')) $d.data('initial', $d.text().trim());
    var rem = totalSec;
    eiTimers[id] = setInterval(function() {
      rem--;
      if (rem <= 0) {
        clearInterval(eiTimers[id]); eiTimers[id] = null;
        display.textContent = '00:00'; display.style.color = '#FF6B4A';
        eiTrack('ei_timer_done', { ei_action: 'timer_done', ei_product: id });
        if (navigator.vibrate) navigator.vibrate([200, 100, 200]);
        return;
      }
      var m = Math.floor(rem / 60), s = rem % 60;
      display.textContent = (m < 10 ? '0' + m : m) + ':' + (s < 10 ? '0' + s : s);
    }, 1000);
  };

  window.eiStopTimer = function(id) {
    if (eiTimers[id]) { clearInterval(eiTimers[id]); eiTimers[id] = null; }
  };

  /* ═══ PRINT ═══ */

  function initPrint() {
    $(document).on('click', '.ei-rc__cta--print', function(e) {
      e.preventDefault(); eiTrack('ei_print', { ei_action: 'print' }); window.print();
    });
  }

  /* ═══ ADD TO CART EVENTS ═══ */

  function initAddToCart() {
    $(document).on('click', '.ei-add-to-cart', function(e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop('disabled')) return;
      var vid = $btn.data('variant-id');
      if (!vid) return;
      var name = $btn.closest('.ei-product-card').find('.ei-product-card__name').text().trim()
              || $btn.closest('.ei-coffret-section').find('.ei-coffret-title').text().trim()
              || 'produit';
      eiTrack('ei_add_to_cart', { ei_action: 'add_single', ei_product: name, ei_variant_id: String(vid) });
      var orig = $btn.text();
      $btn.text('Ajout...').prop('disabled', true);
      ajaxAddToCart(vid, 1, function() {
        $btn.text('Ajout\u00e9 \u2713');
        setTimeout(function() { $btn.text(orig).prop('disabled', false); }, 2000);
      });
    });

    /* Tout ajouter — séquentiel */
    $(document).on('click', '.ei-shoppable-cta-all', function(e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.prop('disabled')) return;
      var items = [];
      $btn.closest('.ei-shoppable-ingredients').find('.ei-add-to-cart').each(function() {
        var v = $(this).data('variant-id');
        if (v) items.push(v);
      });
      if (!items.length) return;
      eiTrack('ei_add_all_to_cart', { ei_action: 'add_all', ei_count: String(items.length) });
      $btn.text('Ajout en cours...').prop('disabled', true);
      var i = 0;
      function next() {
        if (i >= items.length) {
          eiTrack('ei_add_all_to_cart_success', { ei_action: 'add_all_success', ei_count: String(items.length) });
          $btn.text('Tout ajout\u00e9 \u2713');
          setTimeout(function() { $btn.text('Tout ajouter au panier \u2192').prop('disabled', false); }, 3000);
          return;
        }
        ajaxAddToCart(items[i], 1, function() { i++; next(); }, function() { i++; next(); });
      }
      next();
    });

    $(document).on('click', '.ei-ingredient-link', function() {
      eiTrack('ei_ingredient_click', { ei_action: 'ingredient_click', ei_product: $(this).text().trim() });
    });
    $(document).on('click', '#ei-sticky-bar a, #ei-sticky-bar button', function() {
      eiTrack('ei_sticky_bar_click', { ei_action: 'sticky_bar_click' });
    });
  }

  /* ═══ INIT ═══ */

  $(document).ready(function() {
    renderShoppableBlocks();
    renderCoffretBlock();
    setDateBadge();
    initStickyBar();
    initCookMode();
    initTimers();
    initPrint();
    initAddToCart();
  });

  window.eiTrack = eiTrack;

})(jQuery);